function mat4Determinant3(m) {
  return m[0] * (m[5] * m[10] - m[6] * m[9]) + m[1] * (m[6] * m[8] - m[4] * m[10]) + m[2] * (m[4] * m[9] - m[5] * m[8]);
}

export { mat4Determinant3 };
//# sourceMappingURL=mat4-determinant3.js.map
